module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Medium.52ea0d70.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/themes/fonts/SFProDisplay-Medium.woff2
// module id = 333
// module chunks = 1